import type { ReactionModel } from './Reactions.types';
import { reactionsState } from './reactionsState';

export const updateReactionInSharedState = (payload: ReactionModel) => {
  // replace the tempReaction (without an id) with the payload
  reactionsState.setValue({
    ...reactionsState.value,
    reactions: {
      ...reactionsState.value.reactions,
      [payload.idModel]: reactionsState.value.reactions[payload.idModel].map(
        (reaction) => {
          if (
            reaction.idEmoji.toUpperCase() === payload.idEmoji.toUpperCase() &&
            reaction.idMember === payload.idMember
          ) {
            return payload;
          }
          return reaction;
        },
      ),
    },
  });

  // Update pendingUpdates as well. The user could have added a pendingUpdate to
  // remove the reaction while the "add reaction" API call was in progress.
  for (const idUpdate in reactionsState.value.pendingUpdates) {
    const { reaction, idAction } =
      reactionsState.value.pendingUpdates[idUpdate];

    if (
      idAction === payload.idModel &&
      reaction.idEmoji.toUpperCase() === payload.idEmoji.toUpperCase() &&
      reaction.idMember === payload.idMember
    ) {
      reactionsState.setValue({
        ...reactionsState.value,
        pendingUpdates: {
          ...reactionsState.value.pendingUpdates,
          [idUpdate]: {
            ...reactionsState.value.pendingUpdates[idUpdate],
            reaction: payload,
          },
        },
      });
    }
  }
};
